/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

export default {
  track(category, action, label, value) {
    if (global.ga) {
      global.ga('send', 'event', category, action, label, value)
    }
  },

  setup() {
    //
    if (global.ga) {
      global.ga('create', process.env.GA, 'auto')
    }
  },

  init() {
    // Init snippet
    (function(i, s, o, g, r, a, m) {
      i['GoogleAnalyticsObject'] = r
      i[r] = i[r] || function() {
        (i[r].q = i[r].q || []).push(arguments)
      }
      i[r].l = 1 * new Date()
      a = s.createElement(o)
      m = s.getElementsByTagName(o)[0]
      a.async = 1
      a.src = g
      m.parentNode.insertBefore(a, m)
    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga')
  }
}



// WEBPACK FOOTER //
// ./src/components/google-analytics/index.js